'use strict';

angular.module('far.models.mountains.routes', [])
	.service('mountainRoutes', function($log, $http) {
		var list = [],
			firstListQuery = true,
			listQueryProgress = false;

		Object.defineProperty(this, 'list', {
			get: function() {
				if (firstListQuery && !listQueryProgress) {
					listQueryProgress = true;

					$http.get(Routing.generate(''))
						.then(function(response) {
							response.data.forEach(function(routeData) {
								list.push(new Mountain(routeData));
							});

							firstListQuery = false;
							listQueryProgress = false;
						})
						.catch(function(response) {
							listQueryProgress = false;
							$log.error(response);
						});
				}

				return list;
			}
		});

		this.new = function(routeData) {
			return new MountainRoute(routeData);
		};

		this.delete = function(route, callback) {
			return $http.delete(Routing.generate('api_entities_delete_mountain_route', {mountainRoute: route.id}))
					.then(function() {
						route = null;

						if (typeof callback == 'function') {
							callback();
						}
					})
					.catch(function(response) {
						$log.error(response);
					});
		};

		this.restore = function(region, callback) {
			return $http.patch(Routing.generate('api_entities_patch_mountain_route', {id: region.id}))
					.then(function() {
						if (typeof callback == 'function') {
							callback();
						}
					})
					.catch(function(response) {
						$log.error(response);
					});
		};

		this.get = function(routeId, callback) {
			var route = new MountainRoute({});

			$http.get(Routing.generate('api_entities_get_mountainroute', {mountainRoute: routeId}))
				.then(function(response) {
					route.update(response.data);

					if (typeof callback == 'function') {
						callback(route);
					}
				})
				.catch(function(response) {
					$log.error(response);
				});

			return route;
		};

		this.getPopular = function(filters) {
			filters = angular.merge({
				offset: 0,
				limit: 8,
				order_by: 'ascents_count,desc',
				with_images: true
			}, filters);

			return $http.get(Routing.generate('api_entities_get_mountainroutes', filters))
				.then(function(response) {
					return response.data;
				}).catch(function(response) {
					$log.error(response);
					return $q.reject(response);
				});
		};

		function MountainRoute(routeData) {
			angular.merge(this, routeData);

			Object.defineProperty(this, 'update', {
				enumerable: false,
				get: function() {
					return function(mountainData) {
						angular.merge(this, mountainData);

						return this;
					}
				}
			});

			Object.defineProperty(this, 'save', {
				enumerable: false,
				get: function() {
					return function() {
						var method = this.id ? 'put' : 'post',
							url = this.id ?
								Routing.generate('api_entities_put_mountain_route', {mountainRoute: this.id}) :
								Routing.generate('api_entities_post_mountain_route');

						// TODO: Грязный хак
						var data = angular.merge({}, this);

						var peaks = [];

						angular.forEach(data.mountain_peaks, function(peak) {
							if ( peaks.indexOf( peak.id ) == -1 ) {
								peaks.push( peak.id );
							}
						});

						data.mountain_peaks = peaks;
						data.mountain_route_type = data.mountain_route_type.id;
						data.mountain_route_complexity = data.mountain_route_complexity.id;
						data.user = data.user.id;

						angular.forEach(data.documents_files, function(document_file, i) {
							data.documents_files[i]=document_file;
						});

                        if (angular.isObject(data.camp)) {
                            data.camp = data.camp.id;
                        }

						return $http[method](url, data);
					}
				}
			});
		}
	});